//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, tool, commonData } from "@/mixins/index";
import passwordEdit from "./components/passwordEdit";
import addAccount from "./components/addAccount";
import accountEdit from "./components/accountEdit";
import associationPhone from "./components/associationPhone.vue";
export default {
  name: "accountLogin",
  mixins: [loadMoreList, tool, commonData],
  components: {
    passwordEdit: passwordEdit,
    addAccount: addAccount,
    accountEdit: accountEdit,
    associationPhone: associationPhone
  },
  data: function data() {
    return {
      pagingReqFn: "accountList",
      paramsData: {
        isMustAppid: 1
      },
      columns: []
    };
  },
  created: function created() {},
  activated: function activated() {
    this.getcommonData(['appListAllData']);
    console.log(" this.getcommonData(['appListAllData'])", this.getcommonData(['appListAllData']));
  },
  methods: {
    getListNew: function getListNew(e) {
      if (this.paramsData.appid) {
        this.getList(e);
      }
    },
    exportDataFn: function exportDataFn() {
      this.columns = [{
        label: '用户ID',
        prop: 'user_id'
      }, {
        label: '网关用户ID',
        prop: 'gate_user_id'
      }, {
        label: '账号',
        prop: 'account'
      }, {
        label: '创建时间',
        prop: 'create_time'
      }];
      this.exportData();
    }
  }
};